<div class="d-flex justify-content-center align-items-center">
  <app-full-page-spinner *ngIf="loading$ | async"></app-full-page-spinner>
  <div class="card shadow-sm card-container">
    <div class="card-body text-center p-4 p-md-5">
      <h1 class="h3 text-dark mb-3" i18n>Thank you for your order!</h1>
      <p class="text-muted small mb-4 lh-base" i18n>
        Your order has been confirmed and you will receive an order confirmation via
        {{ successMesage }} shortly
      </p>

      <div class="border-top pt-4">
        <h2 class="h5 text-dark mb-3" i18n>
          Create an Account to View and Track All Your Orders
        </h2>

        <div class="form-check text-start mb-3">
          <input
            type="checkbox"
            id="shareInfo"
            [(ngModel)]="shareContactInfo"
            class="form-check-input purple-accent"
          />
          <label for="shareInfo" class="form-check-label small text-dark" i18n>
            Share my contact information with my Consultant.
          </label>
        </div>

        <button
          class="btn btn-lg w-100 text-white btn-primary-custom"
          (click)="createAccount()"
          i18n
          >CREATE ACCOUNT
        </button>
        <div class="validation-error-message col-12 mb-2" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>
      </div>
    </div>
  </div>
</div>
